import { useState, useEffect } from 'react'
import { isDesktop } from '@/lib/platform'
import { isSwUpdateAvailable, subscribeSwUpdate } from '@/lib/sw-update-signal'

export function useSwUpdate() {
  const [updateAvailable, setUpdateAvailable] = useState(isSwUpdateAvailable)

  useEffect(() => {
    // Desktop updates are handled by Electron's bg-updater + titlebar indicator
    if (isDesktop()) return

    // Subscribe first, then check the flag — guarantees no missed signals
    const unsub = subscribeSwUpdate(() => setUpdateAvailable(true))

    if (isSwUpdateAvailable()) {
      setUpdateAvailable(true)
    }

    return unsub
  }, [])

  const applyUpdate = () => {
    const reg = navigator.serviceWorker?.controller
    if (reg) {
      // Wait for the new service worker to take control before reloading,
      // so the reload fetches from the new precache (not stale asset hashes)
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        window.location.reload()
      })
      navigator.serviceWorker.ready.then((registration) => {
        registration.waiting?.postMessage({ type: 'SKIP_WAITING' })
      })
    } else {
      window.location.reload()
    }
  }

  return { updateAvailable, applyUpdate }
}
